// Productie-config. Erft uit environment.base.ts; enkel de productie-verschillen.
import { baseEnvironment } from "./environment.base";

export const environment = {
  ...baseEnvironment,
  production: true,
  apiUrl: "https://app.assistonline.eu/api/",
  googleAnalyticsId: "G-TDCLRSM5SH",
};
